import React from 'react';
import Router from 'react-router';
import Base from 'client/components/base';
import Header from 'client/components/header';
import Footer from 'client/components/footer';
import Consent from 'client/components/consent';
import Divider from 'client/components/common/divider';
import RouteStore from 'client/stores/route';

export default class Navigation extends Base {
  render() {
    return (
      <div>
        <Header />
        {this.props.children}
        <Consent />
        <Footer />
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./client/components/navigation.es6